<template>
	<validation-provider
			:name="'AdminSelectTrainingCourseCode-' + contentKey + '-' + inputItemKey"
			:rules="getValidationRules(contents[contentKey].inputItems[inputItemKey].rules)"
			v-slot="{ errors }">
		<v-autocomplete
				v-model="$store.state.admin.input[inputItemKey]"
				:items="arrayObject($_admnSlctTrnCrsId_stateAdminTrainings())"
				item-text="key"
				item-value="key"
				placeholder="Training Course Code"
				@change="$_admnSlctTrnCrsId_setAdminState()"
				:error-messages="errors" />
	</validation-provider>
</template>

<script>
	export default {
		name: 'AdminSelectTrainingCourseCode',
		props: {
			contentKey: String,
			inputItemKey: String,
			contents: Object,
			inits: Object
		},
		computed: {
			$_admnSlctTrnCrsId_stateAdminTrainings() {
				const self_ = this;
				return () => {
					return self_.getAdminState('trainings')
				}
			}
		},
		created() {
			const self_ = this;
			self_.$_admnSlctTrnCrsId_getTrainings()
		},
		methods: {
			$_admnSlctTrnCrsId_getTrainings() {
				const self_ = this;

				let trainings_ = self_.getAdminState('trainings')

				if(!self_.isEmpty(trainings_)) { return }

				Promise.resolve().then(() => {
					return self_.getFirestoreCollection('trainings', {}, 0)
				}).then(result => {
					self_.setAdminState('trainings', result)
				})
			},
			$_admnSlctTrnCrsId_setAdminState() {
				const self_ = this;

				self_.$_admnSlctTrnCrsId_setAdminStateInput()
				self_.$_admnSlctTrnCrsId_setAdminStateTrainings()
			},
			$_admnSlctTrnCrsId_setAdminStateInput() {
				const self_ = this;

				const input_ = self_.getAdminState('input')
				const courseCode_ = input_[self_.inputItemKey]
				input_.trainingCourseTitle = self_.getLangsVal(self_.adminGetTraining(courseCode_, null, null, 'title'))

				self_.setAdminState('input', input_)
			},
			$_admnSlctTrnCrsId_setAdminStateTrainings() {
				const self_ = this;

				let trainings_ = self_.$_admnSlctTrnCrsId_stateAdminTrainings()

				const input_ = self_.getAdminState('input')
				const courseCode_ = input_[self_.inputItemKey]

				if(self_.isFalse(courseCode_) || !self_.isEmpty(trainings_[courseCode_].modules)) { return null }

				Promise.resolve().then(() => {
					return self_.getFirestoreSubCollection('trainings', courseCode_, 'modules')
				}).then(result => {
					trainings_[courseCode_].modules = result;
					self_.setAdminState('trainings', trainings_)
				})
			}
		}
	}
</script>

<style scoped>
</style>
